import { DateWrap, maxTextLines, nameStyle} from 'Shared/frontend/Poster';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';
import { css } from '@emotion/css';
import { For } from 'solid-js';
import { Show } from 'solid-js';
import { genreList } from 'Shared/common/Macros';
import { poster } from 'Shared/frontend/SettingsProvider';


export const commonGenresStyle = () => css({
	textTransform: 'lowercase',
	lineHeight: 2,
	fontSize: '0.7em',
	...maxTextLines(2),

});

export function actImageUrl(image)
{
	if (!image?.hash)
		return '';
	return useUrls().createVenueImageUrl(image.hash,image,'Lineup-image','medium',useProxyProductionImages());
}


export function FallbackMusicPoster(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'fiveActs');

	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center'
	});

	const eventNameStyle = () => css(nameStyle(theme()), {
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: 18
	});


	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! hide().includes('name');

	return (
		<DateWrap {...P}>
			<div class={posterStyle()}>
				<Show when={showName()}>
					<div class={eventNameStyle()}>{ P.name }</div>
				</Show>

				<For each={P.lineup}>{item =>
					<Artist {...item} hide={hide()} 
						fontSize={s().artistNamesFontSize ?? theme().artistNames.fontSize} 
					/>
				}</For>
			</div>
		</DateWrap>
	);
}

function Artist(P)
{
	const artistNameStyle = () => css({
		width: '100%', 
		fontSize: P.fontSize
	});

	const artistStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch'
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.7em'
	});

//TODO larger fonts for fewer acts 
//TODO add a border

	return (
		<div class={artistStyle()}>
			<Show when={! P.hide.includes('artistName') && P.name}>
				<div class={artistNameStyle()}>{P.name}</div>
			</Show>
			<Show when={! P.hide.includes('artistGenres') && P.mainGenre}>
				<div class={genresStyle()}>{ genreList(P) }</div>
			</Show>
		</div>
	);
}

